import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import {
  CheckCircle,
  RadioButtonUnchecked,
  DownloadOutlined as DownloadIcon,
} from "@mui/icons-material";
import { backendGet } from "@accredo/fe-shared/services/dataService.js";
import { dimensions } from "@accredo/fe-shared/theme/index.js";
import Button from "@accredo/fe-shared/theme/components/Button.jsx";

const UserImportHelp = () => {
  const handleDownloadTemplate = async () => {
    const data = await backendGet("data/benutzers/import-template", {
      label: "Benutzerimport-Vorlage",
      options: {
        responseType: "blob",
        headers: {
          Accept:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
      },
    });

    if (!data) {
      return;
    }

    const download_url = window.URL.createObjectURL(data);
    const link = document.createElement("a");
    link.href = download_url;
    link.download = "benutzer_import_vorlage.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(download_url);
  };

  return (
    <Box
      sx={{
        mt: dimensions["3xl"],
        mb: 3,
      }}
    >
      <Typography variant="h6" gutterBottom>
        Hilfe zum Benutzerimport
      </Typography>
      <Typography variant="body2" paragraph>
        Bitte laden Sie eine XLSX-Datei hoch, die die folgenden Spalten enthält.
        Die Reihenfolge der Spalten ist unerheblich. Eine Vorlagedatei können
        Sie hier herunterladen:
      </Typography>
      <Button
        variant="tertiary"
        startIcon={<DownloadIcon size="16" />}
        onClick={handleDownloadTemplate}
        sx={{ mb: 2 }}
      >
        Vorlage herunterladen
      </Button>
      <Typography variant="subtitle1" gutterBottom>
        Benötigte Spalten:
      </Typography>
      <List dense>
        <ListItem>
          <ListItemIcon>
            <CheckCircle color="success" fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary="email"
            secondary="Eindeutige E-Mail-Adresse des Benutzers. Wird als Login verwendet. Achtung: Falls die E-Mail-Adresse bereits existiert, wird der Benutzer mit den angegebenen Daten aktualisiert."
          />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <CheckCircle color="success" fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="anrede" secondary="z.B. 'Herr' oder 'Frau'." />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <CheckCircle color="success" fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="vorname" />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <CheckCircle color="success" fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="nachname" />
        </ListItem>
      </List>
      <Typography variant="subtitle1" gutterBottom>
        Optionale Spalten:
      </Typography>
      <List dense>
        <ListItem>
          <ListItemIcon>
            <RadioButtonUnchecked color="disabled" fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary="rolle"
            secondary="'kd_aussendienst', 'kd_eingeschraenkt', 'kd_kundenportal_eingeschraenkt' oder 'kd_verwaltung'. Standard (wenn leer): 'kd_aussendienst'."
          />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <RadioButtonUnchecked color="disabled" fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="titel" />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <RadioButtonUnchecked color="disabled" fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="strasse" />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <RadioButtonUnchecked color="disabled" fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="plz" />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <RadioButtonUnchecked color="disabled" fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="ort" />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <RadioButtonUnchecked color="disabled" fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="telefon" />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <RadioButtonUnchecked color="disabled" fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="telefax" />
        </ListItem>
      </List>
    </Box>
  );
};

export default UserImportHelp;
